(function() {
    'use strict';
    angular.module('app')
        .controller('CarriersServicesEditController', function($scope, $location) {
            $scope.currencies = [
                {name: "AUD", value: "AUD"},
                {name: "USD", value: "USD"},
                {name: "RUB", value: "RUB"},
            ];

            $scope.countries = [
                {name: "Russian Federation", value: "rf"},
                {name: "Australia", value: "aus"},
                {name: "United States", value: "us"},
            ];

            $scope.rates = [
                {name: "Cents per KG", value: "cent"},
                {name: "Flat Rate Threshold", value: "flat"},
            ];
        });
})();


// WEBPACK FOOTER //
// ./js/controllers/carriers/CarriersServicesEditController.js